import {defineMessages, FormattedMessage} from 'react-intl';
import {useCallback, useEffect, useState} from 'react';
import {customers} from '@sail/icons/react/Icon';
import {Button, Icon} from '@sail/ui';
import {useWidget} from '../useWidget';

const messages = defineMessages({
  shareScreenButton: {
    id: 'conversations_ui.widget.liveChatTopBar.shareScreenButton',
    description: 'Button to share screen',
    defaultMessage: 'Share screen',
  },
});

type Props = {
  agentJoined: boolean;
};

export const ScreenshareButton = ({agentJoined}: Props) => {
  const widget = useWidget();
  const [isScreenshareActive, setIsScreenshareActive] = useState(false);

  const checkScreenshareStatus = useCallback(async () => {
    try {
      const response = await widget.requestAction(
        {
          name: 'is_screenshare_active',
          data: {},
        },
        {waitForResponse: true},
      );

      if (
        response.data &&
        typeof response.data === 'object' &&
        'is_screenshare_active' in response.data
      ) {
        const isActive = response.data.is_screenshare_active === true;
        setIsScreenshareActive(isActive);
      } else {
        setIsScreenshareActive(false);
      }
    } catch (error) {
      setIsScreenshareActive(false);
    }
  }, [widget]);

  // Poll for screenshare status every 3 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      checkScreenshareStatus();
    }, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, [checkScreenshareStatus]);

  const onNavigateToScreenshare = useCallback(() => {
    // Navigate to screenshare URL in the same tab using the navigate action
    widget.requestAction(
      {
        name: 'request-screenshare',
        data: {},
      },
      {waitForResponse: false},
    );
  }, [widget]);

  return (
    <Button
      size="small"
      onPress={() => {
        onNavigateToScreenshare();
      }}
      data-testid="conversations-widget-share-screen-button"
      css={{flex: 1, gap: 'small', height: '28px'}}
      disabled={!agentJoined || isScreenshareActive}
    >
      <Icon icon={customers} />
      <FormattedMessage {...messages.shareScreenButton} />
    </Button>
  );
};
